import React, { useEffect, useState } from 'react';
import { getAllEmployees } from '../../../api/api';

const AdduserMange = () => {
  const [projectData, setProjectData] = useState({
    employeeName: '',
    role: '',
    access: [],
  });
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [selecteEmployee, setSelecteEmployee] = useState([]);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState('');

  // Separate state for each access category
  const [selectedProjectAccess, setSelectedProjectAccess] = useState([]);
  const [selectedCustomerAccess, setSelectedCustomerAccess] = useState([]);
  const [selectedVendorAccess, setSelectedVendorAccess] = useState([]);
  const [selectedEmployeeAccess, setSelectedEmployeeAccess] = useState([]);
  const [selectedPaymentAccess, setSelectedPaymentAccess] = useState([]);

  const customeraccess = ['name', 'contact', 'Address', 'photo', 'gst', 'status'];
  const vendoraccess = ['name', 'contact', 'Address', 'photo', 'gst', 'status'];
  const employeeaccess = ['name', 'contact', 'Address', 'photo', 'gst', 'status'];
  const paymentaccess = ['name', 'contact', 'Address', 'photo', 'gst', 'status'];
  const projectaccess = ['name', 'conformDate', 'workOrder', 'partNo', 'qty', 'status', 'statusColor', 'employee', 'rev', 'value'];

  useEffect(() => {
    getAllEmployees().then((data) => {
      setSelecteEmployee(data.data);
    });
  }, []);

  const handleAccessClick = (accessType, item) => {
    let setSelectedAccess;

    switch (accessType) {
      case 'project':
        setSelectedAccess = setSelectedProjectAccess;
        break;
      case 'customer':
        setSelectedAccess = setSelectedCustomerAccess;
        break;
      case 'vendor':
        setSelectedAccess = setSelectedVendorAccess;
        break;
      case 'employee':
        setSelectedAccess = setSelectedEmployeeAccess;
        break;
      case 'payment':
        setSelectedAccess = setSelectedPaymentAccess;
        break;
      default:
        return;
    }

    setSelectedAccess((prevSelected) =>
      prevSelected.includes(item)
        ? prevSelected.filter((current) => current !== item)
        : [...prevSelected, item]
    );
  };

  const handleEmployeeChange = (e) => {
    setSelectedEmployeeId(e.target.value);
    setProjectData({ ...projectData, employeeName: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Submitted Data:', projectData);
  };

  return (
    <div className="max-w-2xl mx-auto mt-3 poppins-medium">
      <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Employee Name */}
        <div className="col-span-1">
          <label className="block text-sm font-medium text-gray-700">
            Employee Name<span className="text-red-500">*</span>
          </label>
          <select
            name="employee"
            value={selectedEmployeeId}
            onChange={handleEmployeeChange}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-black focus:border-black"
            required
          >
            <option value="" disabled>
              Select Employee
            </option>
            {selecteEmployee.map((e) => (
              <option key={e._id} value={e._id}>{e.name}</option>
            ))}
          </select>
        </div>

        {/* Project Access Section */}
        <div className="col-span-2">
          <h4 className="bg-black text-white text-lg font-semibold py-2 px-4 rounded-md mb-3">
            Project Access
          </h4>
          <div className="grid grid-cols-2 gap-2">
            {projectaccess.map((project, index) => (
              <div
                key={index}
                onClick={() => handleAccessClick('project', project)}
                className={`cursor-pointer px-4 py-2 poppins-regular rounded-full border flex items-center justify-center transition-colors duration-200 ${
                  selectedProjectAccess.includes(project)
                    ? 'bg-black text-white'
                    : 'bg-white text-gray-700 border-gray-300'
                }`}
              >
                {project}
              </div>
            ))}
          </div>
        </div>

        {/* Customer Access Section */}
        <div className="col-span-2">
          <h4 className="bg-black text-white text-lg font-semibold py-2 px-4 rounded-md mb-3">
            Customer Access
          </h4>
          <div className="grid grid-cols-2 gap-2">
            {customeraccess.map((customer, index) => (
              <div
                key={index}
                onClick={() => handleAccessClick('customer', customer)}
                className={`cursor-pointer px-4 py-2 poppins-regular rounded-full border flex items-center justify-center transition-colors duration-200 ${
                  selectedCustomerAccess.includes(customer)
                    ? 'bg-black text-white'
                    : 'bg-white text-gray-700 border-gray-300'
                }`}
              >
                {customer}
              </div>
            ))}
          </div>
        </div>

        {/* Vendor Access Section */}
        <div className="col-span-2">
          <h4 className="bg-black text-white text-lg font-semibold py-2 px-4 rounded-md mb-3">
            Vendor Access
          </h4>
          <div className="grid grid-cols-2 gap-2">
            {vendoraccess.map((vendor, index) => (
              <div
                key={index}
                onClick={() => handleAccessClick('vendor', vendor)}
                className={`cursor-pointer px-4 py-2 poppins-regular rounded-full border flex items-center justify-center transition-colors duration-200 ${
                  selectedVendorAccess.includes(vendor)
                    ? 'bg-black text-white'
                    : 'bg-white text-gray-700 border-gray-300'
                }`}
              >
                {vendor}
              </div>
            ))}
          </div>
        </div>

        {/* Employee Access Section */}
        <div className="col-span-2">
          <h4 className="bg-black text-white text-lg font-semibold py-2 px-4 rounded-md mb-3">
            Employee Access
          </h4>
          <div className="grid grid-cols-2 gap-2">
            {employeeaccess.map((employee, index) => (
              <div
                key={index}
                onClick={() => handleAccessClick('employee', employee)}
                className={`cursor-pointer px-4 py-2 poppins-regular rounded-full border flex items-center justify-center transition-colors duration-200 ${
                  selectedEmployeeAccess.includes(employee)
                    ? 'bg-black text-white'
                    : 'bg-white text-gray-700 border-gray-300'
                }`}
              >
                {employee}
              </div>
            ))}
          </div>
        </div>

        {/* Payment Access Section */}
        <div className="col-span-2">
          <h4 className="bg-black text-white text-lg font-semibold py-2 px-4 rounded-md mb-3">
            Payment Access
          </h4>
          <div className="grid grid-cols-2 gap-2">
            {paymentaccess.map((payment, index) => (
              <div
                key={index}
                onClick={() => handleAccessClick('payment', payment)}
                className={`cursor-pointer px-4 py-2 poppins-regular rounded-full border flex items-center justify-center transition-colors duration-200 ${
                  selectedPaymentAccess.includes(payment)
                    ? 'bg-black text-white'
                    : 'bg-white text-gray-700 border-gray-300'
                }`}
              >
                {payment}
              </div>
            ))}
          </div>
        </div>

        <button
          type="submit"
          className="mt-5 bg-black text-white px-4 py-2 rounded-md hover:bg-gray-800"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default AdduserMange;
